// where a QuickBooks notification takes the user when clicked, types without a page only get marked as read
export const QUICKBOOK_NOTIFICATION_ROUTES: { [type: string]: string } = {
  bill: 'quickbook/bills',
  billPayment: 'quickbook/bill-payments',
  invoice: 'quickbook/invoices',
  payment: 'quickbook/payments',
  customer: 'quickbook/customers',
  vendor: 'quickbook/vendors',
  service: 'quickbook/services',
};
